import { render, staticRenderFns } from "./Benefit.vue?vue&type=template&id=2ee3f6c2"
import script from "./Benefit.vue?vue&type=script&lang=js"
export * from "./Benefit.vue?vue&type=script&lang=js"
import style0 from "./Benefit.vue?vue&type=style&index=0&id=2ee3f6c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports